export type ReviewAnswerTemplateVariableHintLocale = 'ru' | 'en' | 'uz' | 'uzCyrl';

export const REVIEW_ANSWER_TEMPLATE_PLACEHOLDERS = {
    customerName: '[имя]',
    brand: '[бренд]',
    store: '[магазин]',
} as const;

const DEFAULT_REVIEW_ANSWER_TEMPLATE_VARIABLE_HINT_LOCALE: ReviewAnswerTemplateVariableHintLocale = 'ru';

const normalizeReviewAnswerTemplateVariableHintLocale = (locale: unknown): ReviewAnswerTemplateVariableHintLocale => {
    if (locale === 'uz-Cyrl') {
        return 'uzCyrl';
    }

    return locale === 'ru' || locale === 'en' || locale === 'uz' || locale === 'uzCyrl'
        ? locale
        : DEFAULT_REVIEW_ANSWER_TEMPLATE_VARIABLE_HINT_LOCALE;
};

const { customerName, brand, store } = REVIEW_ANSWER_TEMPLATE_PLACEHOLDERS;

const REVIEW_ANSWER_TEMPLATE_VARIABLE_HINT_TEXTS = {
    ru: `${customerName}, ${brand} и ${store} автоматически заменяются при отправке.`,
    en: `${customerName}, ${brand}, and ${store} are replaced automatically when sending.`,
    uz: `${customerName}, ${brand} va ${store} yuborishda avtomatik almashtiriladi.`,
    uzCyrl: `${customerName}, ${brand} ва ${store} юборишда автоматик алмаштирилади.`,
} as const satisfies Record<ReviewAnswerTemplateVariableHintLocale, string>;

export const getReviewAnswerTemplateVariableHintText = (locale: unknown = 'ru'): string => {
    const normalizedLocale = normalizeReviewAnswerTemplateVariableHintLocale(locale);

    return REVIEW_ANSWER_TEMPLATE_VARIABLE_HINT_TEXTS[normalizedLocale];
};
